<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Daftar Transaksi Online</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="12" xl="6">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="filter.start" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="filter.end" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                            <b-form-input
                                v-model="filter.noFaktur" name="filterNoFaktur"
                                type="search"
                                id="filterNoFaktur"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="12" lg="12" xl="6">
                        <b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                                <multiselect
                                        class="ml-0"
                                        name="filterCabang"
                                        v-model="filter.cabang" 
                                        :options="optCabang" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Pilih filter cabang --"
                                    />
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterVoidStatus" label="Status">
                            <b-form-select v-model="filter.status" id="filterVoidStatus" name="status">
                                <b-select-option value="-1">Semua Status</b-select-option>
                                <b-select-option value="0">Baru</b-select-option>
                                <b-select-option value="1">Terbayar</b-select-option>
                                <b-select-option value="2">Void</b-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="getItems()"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty 
                :busy="isBusy" 
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle mr-2"></b-spinner>
                        <strong>Mengambil data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data transaksi online.
                </template>
                <template v-slot:cell(noKwitansi)="row">
                    <p class="mb-0">{{row.item.noKwitansi}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.noFaktur}}</p>
                </template>
                <template v-slot:cell(namaAnggota)="row">
                    <p class="mb-0">{{row.item.namaAnggota}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                </template>
                <template v-slot:cell(barang)="row">
                    <p class="mb-0">{{row.item.jenisBarang}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.merkBarang}} - {{row.item.tipeBarang}}</p>
                </template>
                <template v-slot:cell(tanggal)="row">
                    {{ $helper.changeDateFormat(row.item.tanggalPembayaran) }}
                </template>
                <template v-slot:cell(nominalPembayaran)="row">
                    <div class="text-right no-wrap">
                        <p class="mb-0" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                        <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                    </div>
                    <div class="text-right no-wrap smallText text-muted">
                        <p class="mb-0" v-if="row.item.angsuranPokok == null">Angsuran{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                        <p class="mb-0" v-else>Angsuran Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-2" variant="pgiBtn" v-b-tooltip.hover title="Detail" name="daftarPembayaranHistoryViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="show" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi pembayaran yang baru diinput dan belum ditransaksikan. Seluruh pembayaran BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">TERBAYAR</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah dieksekusi (kwitansi sudah dicetak, kas cabang sudah berubah).</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">REQUEST VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sedang dalam proses VOID.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "kasir-transaksi-online",
    data() {
        return {
            
            initStatus: 0,
            isBusy: true,
            show: 10,

            filter: {
                noFaktur: "",
                status: -1,
                start: null,
                end: null,
                cabang: null
            },

            fields: [
                { key: "cabang", label: "Cabang" },
                { key: "noKwitansi", label: "No. Kwitansi & Faktur" },
                { key: "namaAnggota", label: "Anggota" },
                { key: "barang", label: "Barang" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "tanggal", label: "Tanggal" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" }
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",

            optCabang: []

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            
            let getCabang = this.$axios.get("cabang/all-selection").then(res => {
                this.optCabang = res.data
            })

            let getItems = this.getItems()

            Promise.all([getCabang, getItems]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isNullOrEmpty(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isNullOrEmpty(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isNullOrEmpty(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(!this.$helper.isNullOrEmpty(this.filter.cabang)) {
                param += "&filterCabang=" + this.filter.cabang.id
            }

            return this.$axios.get("gadai-pembayaran/pusat/transaksi-online/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        onReset() {
            this.filter.noFaktur = ""
            this.filter.status = -1
            this.filter.start = null
            this.filter.end = null
            this.filter.cabang = null
            this.getItems()
        }

    },
    created() {
        this.init()
    }
}
</script>